"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("./common");
/**
 * scheme解析器
 */
class Parser {
    constructor(isInApp = false) {
        this.jump = common_1.doAppRedirect;
        this.jumpWebLink = (link, params, open) => {
            /* istanbul ignore next */
            this.jump(this.genWebLink(link, params), this.isInApp ? false : open);
        };
        /**
         * 根据 pageType 和 params 生成一个 scheme 链接
         */
        this.genAppSchemeLinkByType = (pageType, params) => {
            const item = this.map.get(pageType);
            if (!item || typeof item.data2App === "undefined") {
                return `${this.schemeType}://${common_1.generateAddress(pageType, params)}`; // 默认拼接 query
            }
            else {
                return `${this.schemeType}://${item.data2App(params)}`;
            }
        };
        /**
         * 根据 pageType 和 params 生成一个 scheme 链接，并跳转
         */
        this.jumpAppSchemeLink = (pageType, params) => {
            /* istanbul ignore next */
            this.jump(this.genAppSchemeLinkByType(pageType, params));
        };
        this.isAppProtocol = (link) => this.protocolReg.test(link);
        this.getLinkInfoBySchemeLink = (link) => {
            let pageType = null;
            let data = null;
            const protocol = common_1.parse(this.protocolReg, link);
            if (!protocol) {
                return null;
            }
            for (let [cType, { appReg, app2Data, data2Http }] of this.map) {
                if (typeof data2Http === "undefined") {
                    continue;
                }
                if (appReg && appReg.test(link) && typeof app2Data === "function") {
                    pageType = cType;
                    data = app2Data(link, appReg, protocol);
                    break;
                }
                else if (!appReg && protocol.hostname.toLowerCase() === String(cType).toLowerCase()) {
                    pageType = cType;
                    data = protocol.query; // 默认使用 query
                    break;
                }
            }
            return (pageType && data) ? { pageType, data } : null;
        };
        /**
         * 判断是否可以转为 http 链接
         */
        this.canConvertMobileLink = (link) => {
            return !this.isAppProtocol(link) || !!this.getLinkInfoBySchemeLink(link);
        };
        /**
         * 将 scheme/http 链接转为 http 链接
         */
        this.convertToMobileLink = (link) => {
            const linkInfo = this.getLinkInfoBySchemeLink(link);
            return linkInfo ? this.map.get(linkInfo.pageType).data2Http(linkInfo.data) : link;
        };
        this.getLinkInfoByHttpLink = (link) => {
            let pageType = null;
            let data = null;
            for (let [cType, { httpReg, http2Data }] of this.map) {
                const regList = Array.isArray(httpReg) ? httpReg : [httpReg].filter(v => v);
                const reg = regList.find(regex => regex.test(link));
                if (typeof http2Data === "function" && reg) {
                    pageType = cType;
                    data = http2Data(link, reg);
                    break;
                }
            }
            return (pageType && data) ? { pageType, data } : null;
        };
        /**
         * 将 scheme/http 链接转为 scheme 链接
         */
        this.convertToAppSchemeLink = (link) => {
            if (this.isAppProtocol(link)) {
                return link;
            }
            const linkInfo = this.getLinkInfoByHttpLink(link);
            if (linkInfo) {
                return this.genAppSchemeLinkByType(linkInfo.pageType, linkInfo.data);
            }
            else {
                return this.genWebLink(link);
            }
        };
        /**
         * 根据环境自动转换链接
         */
        this.convertToAutoLink = (link) => {
            if (!link) {
                return link;
            }
            if (!this.isAppProtocol(link)) {
                link = common_1.fixHttpLink(link);
            }
            if (this.isInApp) {
                return this.convertToAppSchemeLink(link);
            }
            else {
                return this.convertToMobileLink(link);
            }
        };
        this.isInApp = isInApp;
    }
}
exports.default = Parser;
